import { ModalContainer } from "components/ui/display/ModalContainer"
import { Input } from "components/ui/inputs/Input";
import { useState } from "react";


export const CreateNewNoteModal = ({onSubmit, onDiscard}) => {

    const [newNoteName, setNewNoteName] = useState('');

    return (
        <ModalContainer
            title="Nytt notat"
            description="Opprett ny nytat."
            submitText="Opprett notat"
            discardText="Forkast"
            onSubmit={() => onSubmit(newNoteName)}
            onDiscard={onDiscard}
        >
            <Input
                title="Navn på notat"
                placeholder="Notatnavn..."
                value={newNoteName}
                onChange={(e) => setNewNoteName(e.target.value)}
            />
            
        </ModalContainer>
    )
}